import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceGroupListViewer';
export const useSourceGroupListViewerTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    groups_count: 'Найдено: {{count}} групп',
    expand_all: 'Развернуть все',
    collapse_all: 'Свернуть все',
    stream_count: 'Источников: {{count}}',
    in_work_count: '(В работе: {{count}})',
    selected_streams: 'Выбрано потоков: {{count}}',
    columns: {
      number: '№',
      name: 'Название',
      analytics_statuses: 'Статусы видеоаналитик',
      status: 'Статус источника',
      location: 'Локация',
      id: 'ID источника',
      live: 'Трансляция',
      logs: 'Логи',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    groups_count: 'Found: {{count}} groups',
    expand_all: 'Expand all',
    collapse_all: 'Collapse all',
    stream_count: 'Sources: {{count}}',
    in_work_count: '(Working: {{count}})',
    selected_streams: 'Selected streams: {{count}}',
    columns: {
      number: '#',
      name: 'Name',
      analytics_statuses: 'Video analytics statuses',
      status: 'Source status',
      location: 'Location',
      id: 'Source ID',
      live: 'Live',
      logs: 'Logs',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    groups_count: 'Encontrados: {{count}} grupos',
    expand_all: 'Expandir todo',
    collapse_all: 'Contraer todo',
    stream_count: 'Fuentes: {{count}}',
    in_work_count: '(En trabajo: {{count}})',
    selected_streams: 'Flujos seleccionados: {{count}}',
    columns: {
      number: '№',
      name: 'Nombre',
      analytics_statuses: 'Estados de videoanalíticas',
      status: 'Estado de la fuente',
      location: 'Ubicación',
      id: 'ID de la fuente',
      live: 'Transmisión',
      logs: 'Registros',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    groups_count: 'Encontrados: {{count}} grupos',
    expand_all: 'Expandir tudo',
    collapse_all: 'Recolher tudo',
    stream_count: 'Fontes: {{count}}',
    in_work_count: '(Em trabalho: {{count}})',
    selected_streams: 'Fluxos selecionados: {{count}}',
    columns: {
      number: '№',
      name: 'Nome',
      analytics_statuses: 'Status das videoanalíticas',
      status: 'Status da fonte',
      location: 'Localização',
      id: 'ID da fonte',
      live: 'Transmissão',
      logs: 'Logs',
    },
  },
}) : {}) as Record<string, unknown>;
